import React from 'react';
import { Check } from 'lucide-react';

const subs = {
  1: 'Takes 3 minutes. Every application is reviewed personally.',
  2: 'Help us understand where you are right now.',
  3: 'This is what separates serious traders from the rest.',
  4: 'Last step. Be honest — this helps us make sure we can actually help you.',
};

const StepIndicator = ({ currentStep, totalSteps }) => (
  <div className="mb-8">
    <div className="flex items-center justify-between max-w-2xl mx-auto">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step, idx) => (
        <React.Fragment key={step}>
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200"
              style={{
                background: step < currentStep ? 'rgba(201,162,53,0.5)' : step === currentStep ? '#C9A235' : '#2D2D2D',
                color: step === currentStep ? '#1A0F00' : step < currentStep ? '#C9A235' : 'var(--text-dim)',
                fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: 16,
              }}>
              {step < currentStep ? <Check className="w-5 h-5" /> : step}
            </div>
            <span className="text-xs mt-2 hidden sm:block" style={{
              fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: 10,
              letterSpacing: '0.1em', textTransform: 'uppercase',
              color: step === currentStep ? '#C9A235' : 'var(--text-dim)',
            }}>Step {step}</span>
          </div>
          {idx < totalSteps - 1 && (
            <div className="flex-1 h-0.5 mx-2 transition-all duration-200"
              style={{ background: step < currentStep ? '#C9A235' : '#2D2D2D' }} />
          )}
        </React.Fragment>
      ))}
    </div>
    <div className="text-center mt-6 space-y-1">
      <p style={{ fontFamily: "'Inter',sans-serif", fontWeight: 500, color: 'var(--text-sub)' }}>Step {currentStep} of {totalSteps}</p>
      <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, color: 'var(--text-muted)' }}>{subs[currentStep]}</p>
    </div>
  </div>
);

export default StepIndicator;
